import { ErrorMessage, Field, FieldArray } from 'formik';
import { Button, Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../components/forms';
import { allergyOptions, allergySeverityOptions } from '../../../utils/consts';
import { StepProps } from '../AddChild';

export const HealthInfoForm = ({ touched, errors, values }: StepProps) => {
  return (
    <>
      <FormStepHeader title="Health Info" className="mb-3" />
      <FieldArray
        name="allergies"
        render={(arrayHelpers) => (
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="allergies"
          >
            <Form.Label className="h4">Allergies & Dietary Restrictions</Form.Label>
            <br />
            <Form.Label>Does your child have any dietary restrictions or allergies?</Form.Label>
            <div className="multi-content-scroll">
              {values.allergies && values.allergies.length > 0 ? (
                values.allergies.map((a, index) => {
                  let meta = {
                    touched: touched.allergies ? touched.allergies[index] : {},
                    error: errors.allergies ? (errors.allergies[index] ?? {}) : {}
                  };

                  return (
                    <div key={index}>
                      <Row>
                        <Col>
                          <Row className="g-2 mb-1">
                            <Col
                              xs={6}
                              className="pe-1"
                            >
                              <FormLabel
                                htmlFor={`allergies.${index}.allergy`}
                                className="mb-0"
                                required
                              >
                                Allergy / Dietary Restriction
                              </FormLabel>
                            </Col>
                            <Col
                              xs={6}
                              className="ps-1"
                            >
                              <FormLabel
                                htmlFor={`allergies.${index}.severity`}
                                className="mb-0"
                              >
                                Severity
                              </FormLabel>
                            </Col>
                          </Row>
                          <Row className="g-2">
                            <Col
                              xs={6}
                              className="pe-1"
                            >
                              <Form.Group
                                className="mb-lg-3 mb-1"
                                controlId={`allergies.${index}.allergy`}
                              >
                                <Field
                                  id={`allergies.${index}.allergy`}
                                  name={`allergies.${index}.allergy`}
                                  as={Form.Select}
                                  options={['2', '3']}
                                  placeholder="Select"
                                  isInvalid={
                                    meta.touched?.allergy &&
                                    !!(typeof meta.error === 'string'
                                      ? meta.error
                                      : meta.error.allergy)
                                  }
                                  aria-required
                                >
                                  <option>Select</option>
                                  {allergyOptions.map((allergy) => (
                                    <option
                                      value={allergy}
                                      key={allergy}
                                    >
                                      {allergy}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage name={`allergies.${index}.allergy`}>
                                  {(msg) => (
                                    <FormControl.Feedback type="invalid">
                                      {msg}
                                    </FormControl.Feedback>
                                  )}
                                </ErrorMessage>
                              </Form.Group>
                            </Col>
                            <Col
                              xs={6}
                              className="ps-1"
                            >
                              <Form.Group
                                className="mb-lg-3 mb-1"
                                controlId={`allergies.${index}.severity`}
                              >
                                <Field
                                  id={`allergies.${index}.severity`}
                                  name={`allergies.${index}.severity`}
                                  as={Form.Select}
                                  options={['2', '3']}
                                  placeholder="Select"
                                >
                                  <option>Select</option>
                                  {allergySeverityOptions.map((opt) => (
                                    <option
                                      value={opt}
                                      key={opt}
                                    >
                                      {opt}
                                    </option>
                                  ))}
                                </Field>
                              </Form.Group>
                            </Col>
                            <Col>
                              <Form.Group
                                className="mb-lg-3 mb-1"
                                controlId={`allergies.${index}.details`}
                              >
                                <FormLabel>Details</FormLabel>
                                <Field
                                  name={`allergies.${index}.details`}
                                  as={Form.Control}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          xs={1}
                          offset={11}
                          className="pe-1"
                        >
                          <Button
                            size="sm"
                            variant="outline-tertiary"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            x
                          </Button>
                        </Col>
                      </Row>
                      {index < values.allergies.length - 1 ? <hr /> : <></>}
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </div>
            <button
              type="button"
              className="btn btn-sm btn-link fw-bolder text-uppercase link-primary link-underline-opacity-0"
              onClick={() =>
                arrayHelpers.insert(values.allergies.length, {
                  allergy: 'new',
                  severity: 'New',
                  details: ''
                })
              }
            >
              + Add Allergy or Dietary Restriction
            </button>
            <ErrorMessage name="address">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        )}
      />
      <hr />
      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="social_emotional_needs"
      >
        <Form.Label className="h4">Social & Emotional Needs</Form.Label>
        <br />
        <Form.Label>Does your child have any specific social or emotional needs?</Form.Label>
        <Field
          name="social_emotional_needs"
          type="text"
          as={Form.Control}
          isInvalid={touched.social_emotional_needs && !!errors.social_emotional_needs}
        />
        <Form.Text>
          Please provide any additional details regarding how we can best support your child's
          social and emotional needs while in our cooking classes.
        </Form.Text>
        <ErrorMessage name="social_emotional_needs">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>
    </>
  );
};
